import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex w-100 flex-column" }
const _hoisted_2 = { class: "navbar navbar-expand-lg navbar-dark bg-dark navbar-props" }
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = { class: "d-flex w-100 justify-content-between menu-panel" }
const _hoisted_5 = { class: "navbar-nav menugap" }
const _hoisted_6 = { class: "nav-item dropdown" }
const _hoisted_7 = { class: "dropdown-menu" }
const _hoisted_8 = { class: "nav-link dropdown-link" }
const _hoisted_9 = { class: "nav-link dropdown-link" }
const _hoisted_10 = { class: "nav-item" }
const _hoisted_11 = { class: "nav-item" }
const _hoisted_12 = { class: "nav-item" }
const _hoisted_13 = { class: "nav-item" }
const _hoisted_14 = { class: "nav-item dropdown" }
const _hoisted_15 = { class: "dropdown-menu" }
const _hoisted_16 = { class: "nav-link dropdown-link" }
const _hoisted_17 = { class: "nav-link dropdown-link" }
const _hoisted_18 = { class: "nav-item" }
const _hoisted_19 = { class: "nav-item" }
const _hoisted_20 = { class: "nav-item" }
const _hoisted_21 = { class: "nav-item" }
const _hoisted_22 = {
  key: 0,
  class: "navbar-nav buttongap"
}
const _hoisted_23 = { class: "nav-item" }
const _hoisted_24 = {
  key: 1,
  class: "navbar-nav"
}
const _hoisted_25 = { class: "nav-item" }
const _hoisted_26 = { class: "d-flex gap-2 align-items-center" }
const _hoisted_27 = { class: "nav-item" }

import {computed, reactive, ref} from "vue";
import axios from "axios";
import {useRoute} from "vue-router";
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'bootstrap/dist/css/bootstrap.min.css';
import breakpoints from "@/assets/js/breakpoints";
import {useBreakpoint} from "@/utils/useBreakpoint";

import {User} from "@/interfaces/users";
import {useMainStore} from "@/stores/mainStore";
import MobileNavBarMenu from "@/components/sections/menus/MobileNavBarMenu.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'NavbarMenu',
  setup(__props) {

/**
 *
 * Created by Filipe - 24/09/2022
 *
 */
const {isSm, isMd} = useBreakpoint();
const mainStore = useMainStore();
const route = useRoute();
const data = ref<any>({menuOpened: false})

const navToggleBtnRef = ref(null)
const navbarNavRef = ref(null)
/*
onMounted(() => {
    navbarNavRef?.value.addEventListener('show.bs.collapse', () => {
        navToggleBtnRef?.value.classList.add('open');
    });

    navbarNavRef?.value.addEventListener('hide.bs.collapse', () => {
        navToggleBtnRef?.value.classList.remove('open');
    });
})*/

// Collapse the menu when the route changes (mobile only)
const collapseNavbar = () => {
    setTimeout(() => {
        const toggleBtn = navToggleBtnRef.value as HTMLElement | null;
        if (window.innerWidth < breakpoints.xl && toggleBtn?.getAttribute('aria-expanded') === 'true') {
            toggleBtn.click(); // triggers Bootstrap collapse properly
        }
    }, 150); // Delay to allow route animation if needed
};

const state = reactive({
    loggedUser: computed<User | null>(() => mainStore.getLoggedUser),
    isUserLogged: computed<boolean>(() => !!mainStore.getLoggedUser),
    userTitle: computed<string>(() => !!mainStore.getLoggedUser ? mainStore.getLoggedUser.name : 'User'),
    isUserAdmin: computed<boolean>(() => mainStore.isAdmin),
    showMenuItems: computed<boolean>(() => !!mainStore.getLoggedUser && route.name !== 'login' && route.name !== 'recoverPassword'),
    //showSubscribeModal: false,
})

const logoutHandler = async () => {
    collapseNavbar()
    await axios.post('/logout')
    window.location.assign('/')
}

const showLogin = () => {
    collapseNavbar()
    mainStore.showLogin(true)
}

function closeMenu() {
    data.value.menuOpened = false
}

function openMenu() {
    data.value.menuOpened = true
}


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[17] || (_cache[17] = _createElementVNode("a", {
          href: "/",
          class: "navbar-brand"
        }, [
          _createElementVNode("img", {
            class: "logo brand-logo",
            src: "/images/logo.webp",
            alt: "Mergerfilers"
          })
        ], -1)),
        _createElementVNode("button", {
          id: "navToggleBtn",
          class: "navbar-toggler",
          type: "button",
          onClick: _withModifiers(openMenu, ["stop"]),
          ref_key: "navToggleBtnRef",
          ref: navToggleBtnRef,
          "aria-controls": "navbarNav",
          "aria-expanded": "false",
          "aria-label": "Toggle navigation"
        }, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("span", { class: "navbar-toggler-icon" }, null, -1)
        ]))], 512),
        (!_unref(isSm) && !_unref(isMd))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "collapse navbar-collapse",
              id: "navbarNav",
              ref_key: "navbarNavRef",
              ref: navbarNavRef
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("ul", _hoisted_5, [
                  _createElementVNode("li", _hoisted_6, [
                    _cache[3] || (_cache[3] = _createElementVNode("a", {
                      class: "nav-link menu-item dropdown-toggle w-100",
                      href: "#",
                      role: "button",
                      "data-bs-toggle": "dropdown"
                    }, " Guide ", -1)),
                    _createElementVNode("ul", _hoisted_7, [
                      _createElementVNode("li", _hoisted_8, [
                        _createVNode(_component_router_link, {
                          class: "menu-item-2nd",
                          to: { name: 'mergerControlSearch' },
                          onClick: collapseNavbar
                        }, {
                          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                            _createTextVNode(" Merger Control ", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", _hoisted_9, [
                        _createVNode(_component_router_link, {
                          class: "menu-item-2nd",
                          to: { name: 'foreignInvestments' },
                          onClick: collapseNavbar
                        }, {
                          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                            _createTextVNode(" Foreign Investment ", -1)
                          ]))]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _createElementVNode("li", _hoisted_10, [
                    _createVNode(_component_router_link, {
                      to: {name: 'decisions'},
                      onClick: collapseNavbar,
                      "active-class": "active",
                      class: "nav-link menu-item"
                    }, {
                      default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                        _createTextVNode(" Decisions ", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_11, [
                    _createVNode(_component_router_link, {
                      to: {name: 'articles'},
                      onClick: collapseNavbar,
                      "active-class": "active",
                      class: "nav-link menu-item"
                    }, {
                      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                        _createTextVNode(" Articles ", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_12, [
                    _createVNode(_component_router_link, {
                      to: {name: 'newsView'},
                      onClick: collapseNavbar,
                      "active-class": "active",
                      class: "nav-link menu-item"
                    }, {
                      default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                        _createTextVNode(" News ", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_13, [
                    _createVNode(_component_router_link, {
                      to: {name: 'jobsView'},
                      onClick: collapseNavbar,
                      "active-class": "active",
                      class: "nav-link menu-item"
                    }, {
                      default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                        _createTextVNode(" Jobs ", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_14, [
                    _cache[10] || (_cache[10] = _createElementVNode("a", {
                      class: "nav-link menu-item dropdown-toggle w-100",
                      href: "#",
                      role: "button",
                      "data-bs-toggle": "dropdown"
                    }, " Experts ", -1)),
                    _createElementVNode("ul", _hoisted_15, [
                      _createElementVNode("li", _hoisted_16, [
                        _createVNode(_component_router_link, {
                          class: "menu-item-2nd",
                          to: { name: 'expertsLayers' },
                          onClick: collapseNavbar
                        }, {
                          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                            _createTextVNode(" Merger Control ", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", _hoisted_17, [
                        _createVNode(_component_router_link, {
                          class: "menu-item-2nd",
                          to: { name: 'expertsForeignLawyers' },
                          onClick: collapseNavbar
                        }, {
                          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                            _createTextVNode(" Foreign Investment ", -1)
                          ]))]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _createElementVNode("li", _hoisted_18, [
                    _createVNode(_component_router_link, {
                      to: {name: 'authoritiesCompetition'},
                      onClick: collapseNavbar,
                      "active-class": "active",
                      class: "nav-link menu-item"
                    }, {
                      default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                        _createTextVNode(" Authorities ", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_19, [
                    _createVNode(_component_router_link, {
                      to: {name: 'events'},
                      onClick: collapseNavbar,
                      "active-class": "active",
                      class: "nav-link menu-item"
                    }, {
                      default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                        _createTextVNode(" Events ", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_20, [
                    _createVNode(_component_router_link, {
                      to: {name: 'about'},
                      onClick: collapseNavbar,
                      "active-class": "active",
                      class: "nav-link menu-item"
                    }, {
                      default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                        _createTextVNode(" About ", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_21, [
                    _createVNode(_component_router_link, {
                      to: {name: 'maia'},
                      onClick: collapseNavbar,
                      "active-class": "active",
                      class: "nav-link menu-item"
                    }, {
                      default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                        _createTextVNode(" MaiA ", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ]),
                (!state.isUserLogged)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_22, [
                      _createElementVNode("li", { class: "nav-item" }, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btnBlackStyle gen-button",
                          onClick: showLogin
                        }, [...(_cache[15] || (_cache[15] = [
                          _createElementVNode("div", { class: "d-flex justify-content-center align-items-center" }, [
                            _createElementVNode("div", { class: "btnBlackText" }, "Contributor log in")
                          ], -1)
                        ]))])
                      ]),
                      _createElementVNode("li", _hoisted_23, [
                        _createVNode(_component_router_link, {
                          to: {name: 'home', hash: '#newsletterForm'},
                          onClick: collapseNavbar
                        }, {
                          default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                            _createElementVNode("button", {
                              type: "button",
                              class: "btnBlueStyle gen-button"
                            }, [
                              _createElementVNode("div", { class: "d-flex btnBlueStyleInner" }, [
                                _createElementVNode("div", { class: "btnBlueText" }, "Free Updates"),
                                _createElementVNode("span", { class: "material-symbols-outlined material-symbols-outlined-400 arrow-icon" }, "arrow_forward")
                              ])
                            ], -1)
                          ]))]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (state.isUserLogged)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_24, [
                      _createElementVNode("li", _hoisted_25, [
                        _createVNode(_component_router_link, {
                          to: {name: 'userArea'},
                          onClick: collapseNavbar,
                          "active-class": "active",
                          class: "nav-link menu-item"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_26, [
                              _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-user" }),
                              _createTextVNode(" " + _toDisplayString(state.userTitle.split(' ')[0]), 1)
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", _hoisted_27, [
                        _createElementVNode("a", {
                          href: "javascript:void(0)",
                          onClick: logoutHandler,
                          class: "nav-link menu-item"
                        }, [
                          _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-power-off" }),
                          _createTextVNode(" " + _toDisplayString((_unref(isSm) || _unref(isMd)) ? 'Logout' : ''), 1)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 512))
          : _createCommentVNode("", true)
      ])
    ]),
    ((_unref(isSm) || _unref(isMd)) && data.value.menuOpened)
      ? (_openBlock(), _createBlock(MobileNavBarMenu, {
          key: 0,
          isOpen: data.value.menuOpened,
          onClose: closeMenu
        }, null, 8, ["isOpen"]))
      : _createCommentVNode("", true)
  ]))
}
}

})